<!-- ~~~~~~~HTML~~~~~~~ -->
<template>
  <main>

    <div class="container mob-flex-direction position-relative flex-column page_hero">
      <div class="d-flex">
        <div class="container__wrapper col-sm-12 col-md-6 col-lg-7 flex-column">
          <h1 id="container__heading_main">{{ $t('minibus_rental') }}</h1>
          <h3 class="h3 -font h3-font container__heading">{{ $t('passenger_transportation') }}</h3>
        </div>
      </div>

      <div class="container__wrapper col-sm-12 col-md-6 col-lg-7 flex-column d-flex page_hero_bottom">
        <div class="serviceTypeButtons align-items-center align-items-md-start">
          <ButtonComponent id="rentButton" class="typeButtons me-lg-3"
            :class="[serviceType === ServiceTypes.SERVICE_RENT ? 'active' : null]"
            v-on:click="onServiceTypeChange(ServiceTypes.SERVICE_RENT)">
            <template #btnContent>
              {{ $t('minibus_rental') }}
            </template>
          </ButtonComponent>

          <ButtonComponent id="transportationButton" class="typeButtons"
            :class="[serviceType === ServiceTypes.SERVICE_TRANSPORTATION ? 'active' : null]"
            v-on:click="onServiceTypeChange(ServiceTypes.SERVICE_TRANSPORTATION)">
            <template #btnContent>
              {{ $t('passenger_transportation') }}
            </template>
          </ButtonComponent>
        </div>
        <div class="serviceType with_driver_option">
          <template v-if="serviceType === ServiceTypes.SERVICE_RENT">
            <CheckBoxComponent @onClick="isWithDriver" :state="withDriver" :id="'withDriver'" name="withDriver"
              class="checkbox-default">
              <template #checkbox-text>
                <label class="ml-5" for="withDriver">{{ $t('minibus_rent_with_driver') }}</label>
              </template>
            </CheckBoxComponent>
          </template>
          <template v-if="serviceType === ServiceTypes.SERVICE_TRANSPORTATION">
            <CheckBoxComponent @onClick="isRoundTrip" :state="roundTrip" :id="'roundTrip'" name="roundTrip"
              class="checkbox-default">
              <template #checkbox-text>
                <label class="ml-5" for="roundTrip">{{ $t('round_trip') }}</label>
              </template>
            </CheckBoxComponent>
          </template>
        </div>

      </div>


    </div>
    <div>
      <div class="container d-flex mob-flex-direction position-relative flex-column main-service">
        <div class="start-0 w-100 formComponent mt-lg-4 mt-md-3 mt-sm-2">
          <template v-if="serviceType === ServiceTypes.SERVICE_RENT">
            <RentComponent :with-driver="withDriver" />
          </template>
          <template v-if="serviceType === ServiceTypes.SERVICE_TRANSPORTATION">
            <TransportationComponent :round-trip="roundTrip" />
          </template>
        </div>
        <div class="mb-5"></div>
      </div>
    </div>
  </main>
</template>



<!-- ~~~~~~~SCRIPT~~~~~~~ -->
<script lang="ts">
import './home.scss';
import { defineComponent } from 'vue';

//@ts-ignore
import ModalComponent from '../../components/modal/ModalComponent.vue';
// @ts-ignore
import RentComponent from '../../components/Forms/Rent/RentComponent.vue';
// @ts-ignore
import TransportationComponent from '../../components/Forms/Transportation/TransportationComponent.vue';
// @ts-ignore
import ButtonComponent from "../../components/Button/ButtonComponent.vue";
// @ts-ignore
import CheckBoxComponent from "../../components/CheckBox/CheckBoxComponent.vue";

import apiService from "../../services/apiService";
import axios from "axios";
import { useStore } from "vuex";

import { ServiceTypes } from "../../interfaces/enums/ServiceTypes.enum";


export default defineComponent({
  components: {
    CheckBoxComponent,
    ButtonComponent,
    ModalComponent,
    RentComponent,
    TransportationComponent,
  },
  setup() {
    const store = useStore();

    return {
      store
    }
  },
  data() {
    return {
      ServiceTypes: ServiceTypes,
      modelId: "videoCarModal",
      modalTitle: "",
      serviceType: ServiceTypes.SERVICE_RENT,
      withDriver: true,
      roundTrip: false,
    }
  },

  methods: {
    onServiceTypeChange: function (serviceType: ServiceTypes): void {
      this.serviceType = serviceType;

      let payload = <{ prop: string, value: boolean } | null>null;

      switch (serviceType) {
        case ServiceTypes.SERVICE_RENT:
          this.roundTrip = false;
          payload = { prop: 'roundTrip', value: this.roundTrip };
          break;

        case ServiceTypes.SERVICE_TRANSPORTATION:
          this.withDriver = false;
          payload = { prop: 'withDriver', value: this.withDriver };
          break;
      }

      this.store.dispatch('order/updateInitStates', [payload]);
      this.store.dispatch('order/updateInitStates', [{ prop: 'serviceType', value: this.serviceType }]);

    },

    isWithDriver: function (evt: any): void {
      this.withDriver = evt.target.checked;
      this.store.dispatch('order/updateInitStates', [{ prop: 'withDriver', value: this.withDriver }]);
    },

    isRoundTrip: function (evt: any): void {
      this.roundTrip = evt.target.checked;
      this.store.dispatch('order/updateInitStates', [{ prop: 'roundTrip', value: this.roundTrip }]);
    }
  },


  created() {
    axios.get(apiService.pageHomePageEndpoint())
      .then((response) => {
        // ...
      })

    if (this.store.state.order.withDriver === null
      || this.store.state.order.serviceType === null
      || this.store.state.order.roundTrip === null
    ) {
      this.store.dispatch('order/updateInitStates', [{ prop: 'roundTrip', value: this.roundTrip }]);
      this.store.dispatch('order/updateInitStates', [{ prop: 'withDriver', value: this.withDriver }]);
      this.store.dispatch('order/updateInitStates', [{ prop: 'serviceType', value: this.serviceType }]);

      return;
    }
    this.withDriver = this.store.state.order.withDriver;
    this.roundTrip = this.store.state.order.roundTrip;
    this.serviceType = this.store.state.order.serviceType;
  },
});

</script>
